import { COLORS, RANGES, UNITS, WORKTOPS } from './cloudinaryImages'
import { RANGE_PRICES, WORKTOP_PRICES } from './prices'

const sections = [
  {
    id: 'range',
    type: 'range',
    title: 'Våre kjøkkenmodeller',
    shortTitle: 'Kjøkken',
    description: 'Velg din favoritmodell',
    tooltip: {
      title: '',
      description: [
        'Norema tilbyr et bredt utvalg kjøkken i ulike stiler og priser. Vi har både flatpakket kjøkkenog ferdig monterte kjøkken klare for montering på vegg. For nøyaktige priser kontakt din nærmeste Noremaforhandler.',
      ],
    },
    cards: [
      {
        title: 'Pluss',
        collection: 'Norema',
        description:
          'Nett og moderne modell med slette fronter i en varm og mettet gråtone. Gjennom sin nøytrale og lavmælte design, er dette et kjøkken som elegant kan matche alle tenkelige interiørstiler. Pluss passer like godt i en byleilighet som i hytta på fjellet. Kombiner gjerne med hvite veggflater og tilbehør i stål.',
        colors: COLORS.pluss,
        prices: {
          small: RANGE_PRICES.pluss[0],
          medium: RANGE_PRICES.pluss[1],
          large: RANGE_PRICES.pluss[2],
        },
        image: RANGES.pluss,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Fager',
        collection: 'Norema',
        description:
          'Et kjøkken som virkelig lever opp til navnet sitt. Med sine enkle, tradisjonsrike speilfronter har Fager et utseende som stråler av klassisk ynde og sjarm, og som gir deg den herlige følelsen av sommer på landet. Vakre art nouveau-inspirerte vitrinedører med stor- og smårutet sprossemønster er kronen på verket.',
        colors: COLORS.fager,
        prices: {
          small: RANGE_PRICES.fager[0],
          medium: RANGE_PRICES.fager[1],
          large: RANGE_PRICES.fager[2],
        },
        image: RANGES.fager,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Trapes',
        collection: 'Norema',
        description:
          'Klar for å tenke annerledes? Trapes er en utpreget mix-and match-modell som innbyr til et lekent og kreativt kjøkkenmiljø. Her kan du boltre deg med f.eks. aluminium vitrinedører, en luftig frokostbar og åpne hyller som matcher en industriell vindusnisje. Vips! Så har du et heftig kjøkkenlook, som en bar på Ibiza! Modellen finnes i utførelsene ask, eik og sort eik.',
        colors: COLORS.trapes,
        prices: {
          small: RANGE_PRICES.trapes[0],
          medium: RANGE_PRICES.trapes[1],
          large: RANGE_PRICES.trapes[2],
        },
        image: RANGES.trapes,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Areal',
        collection: 'Norema',
        description:
          'Velkommen til duggfrisk og nordisk interiørdesign. For deg som ønsker et gladkjøkken som smiler fra morgen til kveld. Med sine slette fronter har Areal-modellene et rentog grafisk uttrykk med store muligheter for personlige designløsninger. Fåes i fargene Klassisk hvit, beige, lys grå, mellomgrå, mørk grå, lingrønn, grønn, mørk blå.',
        colors: COLORS.areal,
        prices: {
          small: RANGE_PRICES.areal[0],
          medium: RANGE_PRICES.areal[1],
          large: RANGE_PRICES.areal[2],
        },
        image: RANGES.areal,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'System',
        collection: 'Norema',
        description:
          'System fremstår som et delikat og pyntelig staskjøkken i ren og lekker design. Joda, det også. Men denne modellens store fortrinn ligger i de robuste frontene i høytrykkslaminat, som er markedets mest slitesterke materiale for kjøkkeninnredning. Tåler godt slag og støt. Suveren vaskbarhet. Et virkelig brukskjøkken for den aktive familie. Fås i modellene klassisk hvit, klassisk hvit med eikekant og Sort med eikekant.',
        colors: COLORS.system,
        prices: {
          small: RANGE_PRICES.system[0],
          medium: RANGE_PRICES.system[1],
          large: RANGE_PRICES.system[2],
        },
        image: RANGES.system,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Parallell',
        collection: 'Norema',
        description:
          'Velkommen til duggfrisk og nordisk interiørdesign. For deg som ønsker et gladkjøkken som smiler fra morgen til kveld. Med sine slette fronter har Parallell-modellen et rent og grafisk uttrykk med store muligheter for personlige designløsninger. Fås i klassisk hvit og mellomgrå.',
        colors: COLORS.parallel,
        prices: {
          small: RANGE_PRICES.parallel[0],
          medium: RANGE_PRICES.parallel[1],
          large: RANGE_PRICES.parallel[2],
        },
        image: RANGES.parallel,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Kvadrat',
        collection: 'Norema',
        description:
          'Dette er en kjøkkenmodell med slette og slitesterke melaminbelagte fronter. Sjatteringene i modellene med trestruktur gir overflaten et levende og organisk uttrykk. Skap et Nordisk designkjøkken hjemme hos deg med en av våre modeller i kvadrat-familien. Fås i modellene Klassisk Hvit, Lys Alm, Trøffelgrå Eik, Brun Eik og Sort Eik.',
        colors: COLORS.kvadrat,
        prices: {
          small: RANGE_PRICES.kvadrat[0],
          medium: RANGE_PRICES.kvadrat[1],
          large: RANGE_PRICES.kvadrat[2],
        },
        image: RANGES.kvadrat,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Kube',
        collection: 'Norema',
        description:
          'Kube er en moderne og lekker kjøkkenmodell i heltre eik med smal ramme og vakker eikestruktur. Modellen passer like godt til et tradisjonelt kjøkken som i et moderne kjøkken alt etter hvilke tilbehør du velger. Kube - for deg som vil ha litt av alt!',
        colors: COLORS.kube,
        prices: {
          small: RANGE_PRICES.kube[0],
          medium: RANGE_PRICES.kube[1],
          large: RANGE_PRICES.kube[2],
        },
        image: RANGES.kube,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Akse',
        collection: 'Norema',
        description:
          'Design Akse gir kjøkkenet ro og en naturlig varme – et tidløst samlingspunkt i en travel hverdag. Linjene er slanke og rolige. Materialene er rene og enkle. Design Akse åpner for mange gode kombinasjonsmuligheter.',
        colors: COLORS.designAkse,
        prices: {
          small: RANGE_PRICES.designAkse[0],
          medium: RANGE_PRICES.designAkse[1],
          large: RANGE_PRICES.designAkse[2],
        },
        image: RANGES.designAkse,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Aspekt',
        collection: 'Norema',
        description:
          'Less is more. Med denne enkle, stilrene og prisgunstige kjøkkenmodellen kan du skape mye deilig kjøkken for pengene. Aspekt har hvitmalte glatte fronter i ren og presis design. En slik formgivning er svært lett å tilpasse alle boligtyper og romløsninger.',
        colors: COLORS.aspektKlassiskHvit,
        prices: {
          small: RANGE_PRICES.aspektKlassiskHvit[0],
          medium: RANGE_PRICES.aspektKlassiskHvit[1],
          large: RANGE_PRICES.aspektKlassiskHvit[2],
        },
        image: RANGES.aspektKlassiskHvit,
        filterWorktops: ['Laminat', 'Massivt tre', 'Granitt'],
      },
      {
        title: 'Hisøy',
        collection: 'Norema',
        description:
          'Lekker kjøkkenmodell med integrerte grep på skuffer og skapdører. Malt MDF med innfrest grep, 19 mm. Fås i fargene klassisk hvit, lys grå, mellomgrå.',
        colors: COLORS.hisoyGrep,
        prices: {
          small: RANGE_PRICES.hisoyGrep[0],
          medium: RANGE_PRICES.hisoyGrep[1],
          large: RANGE_PRICES.hisoyGrep[2],
        },
        image: RANGES.hisoyGrep,
        filterWorktops: ['Laminat (Basic)'],
      }, // new
      {
        title: 'Norema x Toniton',
        collection: 'Sigdal',
        description:
          'Fargene på Toniton-kjøkkenet er utviklet av en av verdens fremste kolorister, Tekla Severin. Hun har lagt stor vekt på å finne tidløse farger som kler ulike miljøer og personligheter. Fra deg som søker en klassisk og nøye utvalgt tone i grått eller blått, til deg som foretrekker trendy nyanser som gul eller peach. Hele seks lekre farger å velge blant!',
        colors: COLORS.toniton,
        prices: {
          small: RANGE_PRICES.toniton[0],
          medium: RANGE_PRICES.toniton[1],
          large: RANGE_PRICES.toniton[2],
        },
        image: RANGES.toniton,
      },
      {
        title: 'Format',
        collection: 'Sigdal',
        description:
          'Kjøkkenklassiker i moderne design. Frontene har ramtre og slett fylling, en elegant kombinasjon av tradisjonell kjøkkendesign og en moderne touch. Format-serien byr på en stil som er nett og diskret, landlig og litt shakeraktig.',
        colors: COLORS.format,
        prices: {
          small: RANGE_PRICES.format[0],
          medium: RANGE_PRICES.format[1],
          large: RANGE_PRICES.format[2],
        },
        image: RANGES.format,
      },

      // end
      {
        title: 'Nøtterøy',
        collection: 'Norema',
        description:
          'Moderne kjøkkenmodell med slette og slitesterke melaminbelagte fronter 16-19mm MFC. Fås i Brun eik, klassisk hvit, lys alm, mellomgrå, sort tre, trøffelgrå eik.',
        colors: COLORS.notteroy,
        prices: {
          small: RANGE_PRICES.notteroy[0],
          medium: RANGE_PRICES.notteroy[1],
          large: RANGE_PRICES.notteroy[2],
        },
        image: RANGES.notteroy,
        filterWorktops: ['Laminat (Basic)'],
      },
      {
        title: 'Stjernøya',
        collection: 'Norema',
        description:
          'Hyperpraktisk, ujålete og minimalistisk kjøkken med et snev av retropreg. Renholdsvennlige fronter. Malt MDF 19 mm. Fås i fargene beige, grønn, lys grå, mellomgrå.',
        colors: COLORS.stjernoya,
        prices: {
          small: RANGE_PRICES.stjernoya[0],
          medium: RANGE_PRICES.stjernoya[1],
          large: RANGE_PRICES.stjernoya[2],
        },
        image: RANGES.stjernoya,
        filterWorktops: ['Laminat (Basic)'],
      },
      {
        title: 'Tromøy',
        collection: 'Norema',
        description:
          'Tromøy er en “kameleonmodell” som er lett å integrere i et mer nostalgisk kjøkkenmiljø. Profilfrest malt MDF, 16 mm. Fås i fargene klassisk hvit, lys grå, mellomgrå.',
        colors: COLORS.tromoy,
        prices: {
          small: RANGE_PRICES.tromoy[0],
          medium: RANGE_PRICES.tromoy[1],
          large: RANGE_PRICES.tromoy[2],
        },
        image: RANGES.tromoy,
        filterWorktops: ['Laminat (Basic)'],
      },
      {
        title: 'Håøya',
        collection: 'Norema',
        description:
          'Shakerinspirert kjøkkenmodell med ramtrefronter og klassisk sjarm. Malt MDF rammefront med slett speil,19 mm. Fås i fargene klassisk hvit, lys grå, mellomgrå.',
        colors: COLORS.haoya,
        prices: {
          small: RANGE_PRICES.haoya[0],
          medium: RANGE_PRICES.haoya[1],
          large: RANGE_PRICES.haoya[2],
        },
        image: RANGES.haoya,
        filterWorktops: ['Laminat (Basic)'],
      },
      {
        title: 'Asmaløy',
        collection: 'Norema',
        description:
          'Asmaløy har hvitmalte glatte og rengjørings-vennlige fronter. Står godt til utstyr i stål og aluminium. Malt 16 mm MDF.',
        colors: COLORS.asmaloyKlassiskHvit,
        prices: {
          small: RANGE_PRICES.asmaloyKlassiskHvit[0],
          medium: RANGE_PRICES.asmaloyKlassiskHvit[1],
          large: RANGE_PRICES.asmaloyKlassiskHvit[2],
        },
        image: RANGES.asmaloyKlassiskHvit,
        filterWorktops: ['Laminat (Basic)'],
      },
    ],
  },
  {
    id: 'units',
    title: 'Kjøkkenstørrelse',
    shortTitle: 'Størrelse',
    type: 'units',
    description: 'Velg størrelse på kjøkken',
    tooltip: {
      title: '',
      description: [
        'Lite kjøkken rommer 5 underskap, 3 veggskap og 1 høyskap.',
        'Medium kjøkken rommer 8 under-skap, 5 veggskap og 2 høyskap.',
        'Stort kjøkken rommer 12 under-skap, 8 veggskap, 3 høyskap samt kjøkkenøy.',
        'Priser er ekslusiv benkeplate, vask, kran og hvitevarer.',
      ],
    },
    cards: [
      {
        type: 'small',
        title: 'Lite kjøkken',
        price: 0,
        image: UNITS.small,
      },
      {
        type: 'medium',
        title: 'Medium kjøkken',
        price: 0,
        image: UNITS.medium,
      },
      {
        type: 'large',
        title: 'Stort kjøkken',
        price: 0,
        image: UNITS.large,
      },
    ],
  },
  {
    id: 'worktops',
    title: 'Benkeplater',
    type: 'simple',
    description: 'Velg hvilken type benkeplate du vil ha.',
    tooltip: {
      title: '',
      description: [
        'Norema har et bredt utvalgt av ulike benkeplater. Ved å klikke på det materialet du ønskerså får du opp et estimathva dette vil koste på våre3 kjøkkeneksempler.',
        'For å få eksakt pris må du ta kontakt med din nærmeste forhandler.',
      ],
    },
    cards: [
      {
        title: 'Laminat (Basic)',
        description:
          'Benkeplater i laminat finnes i et bredt sortiment med en mengde ulike overflater, mønster og farger.',
        prices: {
          small: WORKTOP_PRICES.laminateBasic[0],
          medium: WORKTOP_PRICES.laminateBasic[1],
          large: WORKTOP_PRICES.laminateBasic[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Laminat',
        description:
          'Benkeplater i laminat finnes i et bredt sortiment med en mengde ulike overflater, mønster og farger.',
        prices: {
          small: WORKTOP_PRICES.laminate[0],
          medium: WORKTOP_PRICES.laminate[1],
          large: WORKTOP_PRICES.laminate[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Massivt tre',
        description:
          'Benkeplater i massivt tre er både levende og varmt, genuint og vakkert som varer over tid.',
        prices: {
          small: WORKTOP_PRICES.solidTimber[0],
          medium: WORKTOP_PRICES.solidTimber[1],
          large: WORKTOP_PRICES.solidTimber[2],
        },
        image: WORKTOPS.wood,
      },
      {
        title: 'Granitt',
        description:
          'De vakre benkeplatene i granitt finnes i en mangde ulike luksuriøse utforminger som passer alle typer kjøkken. Hver plate er unik så du kan være sikker på å få et spesielt kjøkken.',
        prices: {
          small: WORKTOP_PRICES.granite[0],
          medium: WORKTOP_PRICES.granite[1],
          large: WORKTOP_PRICES.granite[2],
        },
        image: WORKTOPS.granite,
      },
    ],
  },
  {
    id: 'estimate',
    title: 'Estimat',
    type: 'summary',
    description: '',
    tooltip: {},
  },
]

export default sections
